<template>
    <mds-layout-grid>
        <mds-row e2e="rebalance-summary">
            <mds-col :cols="3">
                <div class="summary-label">Rebalance to</div>
                <div class="summary-text">{{ rebalanceToValue }}</div>
            </mds-col>
            <mds-col :cols="3">
                <div class="summary-label">Frequency</div>
                <div class="summary-text">{{ frequencyValue }}</div>
            </mds-col>
            <mds-col :cols="3">
                <div class="summary-label">Threshold</div>
                <div class="summary-text">{{ thresholdValue }}</div>
            </mds-col>
        </mds-row>
    </mds-layout-grid>
</template>

<script>
import HypoVueBaseMixin from "hypo-vue-base-mixin";
import { mapState } from "vuex";
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import { MdsLayoutGrid, MdsRow, MdsCol } from "@mds/layout-grid";

export default {
    name: "rebalacing-summary",
    components: {
        MdsLayoutGrid,
        MdsRow,
        MdsCol
    },
    mixins: [HypoVueBaseMixin, MwcSharedMixin],
    data() {
        return {
            defaultConfig: {
                labels: this.$store.state.labels.labels
            }
        };
    },
    computed: {
        ...mapState("rebalancing", ["includeRebalance", "rebalanceType", "frequencyType", "threshold", "rebalanceOptions", "frequencyOptions"]),
        rebalanceToValue() {
            const selectedRebalanceOption = this.rebalanceOptions.find(i => i.value === this.rebalanceType);
            if (!selectedRebalanceOption) {
                return "";
            }
            return this.getUILabel(selectedRebalanceOption.labelId);
        },
        frequencyValue() {
            const selectedFrequencyOption = this.frequencyOptions.find(i => i.value === this.frequencyType);
            if (!selectedFrequencyOption) {
                return "";
            }
            return this.getUILabel(selectedFrequencyOption.labelId);
        },
        thresholdValue() {
            return `${this.formatter.format(this.threshold, "shortDecimal")}%`;
        }
    }
};
</script>
